<template>
    <base-container ref="container" style="height: 100%">
        <ArtisanGrid
            ref="resource"
            metaKey="ZlResourceInfo"
            :rowBtnPermission="rowBtnPermission"
            isTree
            defaultExpandAll
            @ZlRoomAddDevice="roomAddDevice"
            :confirmBefore="confirmBefore"
            :showDialogBefore="showDialogBefore"
            :metaInited="metaInited"
            :leftOption="leftOption"
            dialogWidth="80%"
            dialogHeight="80%"
        >
            <template #leftAside>
                <el-tree
                    :data="treeData"
                    node-key="id"
                    default-expand-all
                    ref="tree"
                    highlight-current
                    :props="{ label: 'name' }"
                    :expand-on-click-node="false"
                    @current-change="treeChange"
                >
                </el-tree>
            </template>
            <template #dialogRight>
                <artisan-group style="width: 50%; height: 100%" title="设备治疗项目">
                    <el-row style="margin-bottom: 10px">
                        <el-col :span="12">
                            <el-select size="mini" v-model="projectType" style="width: 100%">
                                <el-option value="">所有</el-option>
                                <el-option
                                    :value="item.value"
                                    :label="item.label"
                                    v-for="item in projectTypes"
                                    :key="item.value"
                                ></el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <el-input
                                size="mini"
                                v-model="val"
                                placeholder="搜索关键字"
                            ></el-input>
                        </el-col>
                    </el-row>
                    <el-checkbox-group v-model="projectIds">
                        <div>
                        <el-button type="primary" size="mini" icon="el-icon-check" @click="checkAllProject">全选</el-button>
                        <el-button type="danger" size="mini" icon="el-icon-close" @click="projectIds = []">全不选</el-button>
                        </div>
                        <el-checkbox
                            style="width: 50%; margin-right: 0"
                            v-show="validProject(project)"
                            v-for="project in projects"
                            :key="project.id"
                            :label="project.id"
                        >
                            {{ project.name }}
                        </el-checkbox>
                    </el-checkbox-group>
                </artisan-group>
            </template>
        </ArtisanGrid>
    </base-container>
</template>

<script>
import { listByHos } from "@/api/zl/project";
import { loadEnum } from "@/api/sys/dicType";
import { getUserHosDepts } from "@/api/zl/dept";
export default {
    data() {
        return {
            isLoading: false,
            projectType: "",
            projectTypes: [],
            projects: [],
            projectIds: [],
            val: "",
            data: "",
            hosId: "",
            depts: [],
            deptId: "",
            treeData: [],
            leftOption: {
                width: "15%",
            },
        };
    },
    created() {
        listByHos().then((res) => {
            this.projects = res.data.data;
        });
        loadEnum("ZlProjectTypeOption").then((res) => {
            this.projectTypes = res.data.data;
        });
    },
    methods: {
        validProject(project) {
            return (project.type == this.projectType || !this.projectType) &&
                (project.deptId == this.deptId || !this.deptId) &&
                (project.name.indexOf(this.val) >= 0 || !this.val);
        },
        checkAllProject(){
            const checkProject=this.projects.filter((item)=>{
                if(this.validProject(item)) return true
            }).map((item)=>item.id);
            this.projectIds = this.projectIds.concat(checkProject);
        },
        metaInited(option) {
            const col = option.columns.find((c) => c.code == "deptId");
            col.dicdata = [];
            getUserHosDepts().then((res) => {
                const data = res.data.data;
                data.forEach((c) => {
                    let node = {
                        id: c.id,
                        name: c.name,
                        type: "hos",
                        children: c.zlDepts,
                    };
                    let depts = c.zlDepts.map((c) => {
                        return {
                            value: c.id,
                            label: c.name,
                        };
                    });
                    col.dicData = col.dicData.concat(depts);
                    this.treeData.push(node);
                });
            });
        },
        treeChange(data, node) {
            if (data.type) {
                this.hosId = data.id;
                this.deptId = "";
            } else {
                this.hosId = node.parent.data.id;
                this.deptId = data.id;
            }
            this.$refs.resource.reload({
                hosId: this.hosId,
                deptId: this.deptId,
            });
        },
        rowBtnPermission(row, btn) {
            if (btn.code == "ZlRoomAddDevice") {
                return row.parentId == "0";
            }
            return true;
        },
        showDialogBefore(dialog, data) {
            this.projectType = "";
            this.projectIds = data.projectIds||[];
            dialog.isShow = true;
        },
        confirmBefore(dialog, data) {
            data.projectIds = this.projectIds;
            return true;
        },
        roomAddDevice(row, btn) {
            btn.title = "添加设备--" + row.name;
            let data = {
                type: "device",
                parentId: row.id,
                deptId: row.deptId,
                projectIds: [],
            };
            this.$refs.resource.toAdd(btn, data);
        },
    },
};
</script>

<style scoped></style>
